export const VOUCHER_STATUSES = {
  USED: "Iskorišćen vaučer",
  UNUSED: "Neiskorišćen vaučer",
  EXPIRED: "Istekao vaučer",
} as const;
export type VoucherStatus = keyof typeof VOUCHER_STATUSES;
